jQuery(($) => {
    console.log("loonar.io");

    document.addEventListener('wpcf7submit', function(e) {
        const form = $(e.target);
        const errors = form.find('.e-field .wpcf7-not-valid');
        form.find('.e-field').removeClass('e-field--error');
        if(errors.length > 0) {
            errors.each((index, el) => {
                $(el).closest('.e-field').addClass('e-field--error');
            });
        }
    });

    if($('.wpcf7 select').length > 0) {
        let options = [];
        $('.wpcf7 select option').each((index, el) => {
            options.push($(el).text());
        });

        $('.wpcf7 .e-select .e-select__options').html("");

        let html = "";
        options.forEach((el, index) => {
            if(index == 0) return;
            html += `<p class="e-select__option">${el}</p>`;
        });

        if(html) $('.wpcf7 .e-select .e-select__options').html(html);
    }

    // svg inject
    const svgs = document.querySelectorAll("img.injectable");
    if (svgs) {
        SVGInject.setOptions({
            onFail: function (img) {
                img.classList.remove("injectable");
            },
        });
        SVGInject(svgs);
    }

    // orphans
    // $('h1, h2, h3, h4, h5, h6, p, li').adopt();

    // masonry layout
    const grid = $(".m-terms__grid");
    if (grid.length > 0) {
        grid.imagesLoaded(function () {
            grid.masonry({
                itemSelector: ".e-term-box",
                horizontalOrder: true,
                percentPosition: true,
                gutter: 30,
            });
        });
    }

    // mobile menu
    $(".header .header__btn").on("click", function (e) {
        e.preventDefault();

        if (!$(this).hasClass("header__btn--active")) {
            $(this).addClass("header__btn--active");

            // open mobile menu
            $(".mobile-nav").addClass("mobile-nav--active");
            bodyScrollLock.disableBodyScroll(
                document.querySelector(".mobile-nav")
            );
        } else {
            $(this).removeClass("header__btn--active");

            // close mobile menu
            $(".mobile-nav").removeClass("mobile-nav--active");
            bodyScrollLock.enableBodyScroll(
                document.querySelector(".mobile-nav")
            );
        }
    });

    // Promo functionality
    // Empty promocode string
    let promoCode = '';

    // Promo codes from admin panel
    const promoCodes = main.promoCodes ?? false;
    let promoExists = false;

    // Link variables
    const pageSearchVariables = window.location.search;

    const searchArray = pageSearchVariables.substring(pageSearchVariables.indexOf('?') + 1).split('&')

    // Trying to get promo_code from page url
    if (searchArray) {
        searchArray.forEach(item => promoCode = item.indexOf('promo_code') !== -1 ? item.substring(item.indexOf('=') + 1) : false);
    }

    // If promo_code exists - set to localStorate
    // else - get from sessionStorage
    if(promoCode) {
        sessionStorage.setItem('promo_code', promoCode);
    } else {
        promoCode = sessionStorage.getItem('promo_code');
    }

    // If we find this promo_code in admin_panel and it's activated - returns promo_code object
    // else - undefined and removing from sessionStorage

    if(promoCodes) {
        promoExists = promoCodes.find(obj => promoCode === obj.promo_code && obj.activate_promo);
    }

    if(promoExists) {
        const today = new Date();
        let dayFrom = promoExists.day_from ? promoExists.day_from.split('/') : false;
        let dayTo = promoExists.day_to ? promoExists.day_to.split('/') : false;

        dayFrom = dayFrom ? new Date(+dayFrom[2], dayFrom[1] - 1, +dayFrom[0]) : new Date('01/01/1970');
        dayTo = dayTo ? new Date(new Date(+dayTo[2], dayTo[1] - 1, +dayTo[0]).setHours(23, 59, 59, 999)) : new Date(new Date('01/01/2099').setHours(23, 59, 59, 999));

        // Checking dates from promo_code object. If it passes - shows promotionBar
        // else - removing from sessionStorage
        if (
            today.getTime() <= dayTo.getTime() &&
            today.getTime() >= dayFrom.getTime()
            ) {
                $('#promotion').addClass('visible');
            } else {
                sessionStorage.removeItem('promo_code');
            }
    } else {
        sessionStorage.removeItem('promo_code');
    }

    // header control
    function headerPosition() {
        const headerBarHeight = $(".header .header__container--right").height();
        const adminBarHeight = $('#wpadminbar').length > 0 ? $('#wpadminbar').height() : 0;
        const promotionBarHeight = $('#promotion').length > 0 && $('#promotion').hasClass('visible') ? $('#promotion').outerHeight() : 0;

        if($('#promotion').length > 0 && $('#promotion').hasClass('visible')) {
            $('body').css({ '--promo-height': `${$('#promotion').outerHeight()}px` })
        }

        if(adminBarHeight) {
            $('#promotion').css('top', `${adminBarHeight}px`)
        }

        if(window.scrollY > headerBarHeight) {
            if($('.header .header__container--right').is(':visible')) {
                $('.header').css('top', `${-(headerBarHeight - adminBarHeight - promotionBarHeight)}px`);
            }
            $('.header').addClass('header--fixed');
        } else {
            $('.header').removeClass('header--fixed');
            $('.header').css('top', `${adminBarHeight + promotionBarHeight}px`);
        }
    }

    headerPosition();

    $(window).on("scroll", headerPosition);
    $(window).on("resize", headerPosition);

    // swipers
    let swipers = [];
    const bannerSlider = $(".m-banner .swiper-container");
    if (bannerSlider.length > 0) {
        const bannerSwiper = new Swiper(".m-banner .swiper-container", {
            slidesPerView: 1,
            threshold: 0,
            speed: 700,
            loop: true,
            pagination: {
                el: ".m-banner .swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                992: {
                    threshold: 25,
                },
            }
        });
        swipers.push(bannerSwiper);
    }

    const offerSlider = $(".m-results .swiper-container");
    if (offerSlider.length > 0) {
        const offerSwiper = new Swiper(".m-results .swiper-container", {
            slidesPerView: 1,
            spaceBetween: 30,
            grabCursor: true,
            speed: 700,
            loop: true,
            navigation: {
                prevEl: ".m-results .swiper-button-prev",
                nextEl: ".m-results .swiper-button-next",
            },
        });
        swipers.push(offerSwiper);
    }

    const newsSlider = $(".m-news .swiper-container");
    if (newsSlider.length > 0) {
        const newsSwiper = new Swiper(".m-news .swiper-container", {
            slideVisibleClass: "swiper-slide-visible",
            slidesPerView: 1,
            spaceBetween: 30,
            touchRatio: 0,
            speed: 700,
            loop: true,
            pagination: {
                el: ".m-news .swiper-pagination",
                clickable: true,
            },
            navigation: {
                prevEl: ".m-news .swiper-button-prev",
                nextEl: ".m-news .swiper-button-next",
            },
            breakpoints: {
                992: {
                    slidesPerView: 3,
                },
                768: {
                    slidesPerView: 2,
                },
            },
        });
        swipers.push(newsSwiper);
    }

    const relatedSlider = $(".m-related .swiper-container");
    if (relatedSlider.length > 0) {
        const relatedSwiper = new Swiper(".m-related .swiper-container", {
            slideVisibleClass: "swiper-slide-visible",
            grabCursor: false,
            slidesPerView: 1,
            spaceBetween: 30,
            touchRatio: 0,
            speed: 700,
            pagination: {
                el: ".m-related .swiper-pagination",
                clickable: true,
            },
            navigation: {
                prevEl: ".m-related .swiper-button-prev",
                nextEl: ".m-related .swiper-button-next",
            },
            breakpoints: {
                992: {
                    slidesPerView: 3,
                },
                768: {
                    slidesPerView: 2,
                },
            },
        });
        swipers.push(relatedSwiper);
    }

    const trustSlider = $(".m-trust .swiper-container");
    const trustSlides = $(".m-trust .swiper-container .swiper-slide").length;
    if (trustSlider.length > 0) {
        const trustSwiper = new Swiper(".m-trust .swiper-container", {
            slidesPerGroup: trustSlides,
            speed: trustSlides * 3500,
            slidesPerView: "auto",
            touchRatio: 0,
            loop: true,
            autoplay: {
                disableOnInteraction: false,
                delay: 0,
            },
        });
        swipers.push(trustSwiper);
    }

    const testimonialsSlider = $(".m-testimonials .swiper-container");
    if (testimonialsSlider.length > 0) {
        const testimonialsSwiper = new Swiper(
            ".m-testimonials .swiper-container",
            {
                slideVisibleClass: "swiper-slide-visible",
                grabCursor: true,
                slidesPerView: 1,
                spaceBetween: 30,
                speed: 700,
                loop: true,
                navigation: {
                    prevEl: ".m-testimonials .swiper-button-prev",
                    nextEl: ".m-testimonials .swiper-button-next",
                },
                breakpoints: {
                    992: {
                        slidesPerView: 3,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                },
            }
        );
        swipers.push(testimonialsSwiper);
    }

    if($('.page-reservations').length <= 0) {

        function leadingZero(number) {
            if (number < 10) number = "0" + number;
            return number;
        }

        function updateDate(date, input) {
            let day = date.getDate("d");
            let month = date.getMonth() + 1;
            const year = date.getFullYear();

            let hour = date.getHours();
            let minute = date.getMinutes();

            day = leadingZero(day);
            month = leadingZero(month);
            hour = leadingZero(hour);
            minute = leadingZero(minute);

            $(input).parent().find(".e-datepicker .month").text(month);
            $(input).parent().find(".e-datepicker .day").text(day);
            $(input).parent().find(".e-datepicker .year").text(year);

            $(input).parent().find(".e-datepicker .hour").text(hour);
            $(input).parent().find(".e-datepicker .minute").text(minute);
        }

        $.datetimepicker.setLocale("pl");
        const now = new Date();
        let defaultTimeString = `${now.getHours() + 2}:00`;

        if (now.getHours() + 2 < 14) defaultTimeString = "14:00";

        function onChangeDateTimeCb(date, input) {
            if(date) {
                updateDate(date, input);
            }
        };

        function onGenerateCb (date, input) {
            updateDate(date, input);
        }

        $('.e-field__datepicker[data-id]').on('click', function(e) {
            e.preventDefault();
            const id = $(this).data('id');
            $(id).datetimepicker('show');
        });

        let pickupTimeGenerated = false;

        $("#pickupTime").datetimepicker({
            defaultTime: defaultTimeString,
            scrollMonth: false,
            minDate: 0,
            onSelectTime: function(date, input) {
                $(input).datetimepicker('setOptions', {
                    opened: false,
                });
            },
            onSelectDate: function(date, input) {
                $(input).addClass('dont-close');
                $(input).datetimepicker('setOptions', {
                    opened: true,
                });
            },
            onClose: function(date, input) {
                if(!$(input).hasClass('dont-close')) {
                    $(input).datetimepicker('setOptions', {
                        opened: false,
                    });
                }
                $(input).removeClass('dont-close');
            },
            onChangeDateTime: function(date, input) {
                const returnDate = $('#returnTime').datetimepicker('getValue');
                let valid = (date >= returnDate) ? false : true;
                onChangeDateTimeCb(date, input);


                if(date >= returnDate) {
                    let newReturnValue = new Date(date);
                    newReturnValue.setDate(newReturnValue.getDate() + 1);
                    updateDate(newReturnValue, $('#returnTime'));
                    $('#returnTime').datetimepicker('setOptions', {
                        value: newReturnValue
                    });
                }

                $('.m-search .e-select').each(function(index, el) {
                    if($(el).find('.e-select__option--active').length == 0) {
                        valid = false;
                    }
                });

                if(valid) {
                    $('.m-search #book').removeClass('e-btn--disabled');
                } else {
                    $('.m-search #book').addClass('e-btn--disabled');
                }
            },
            onGenerate: function(date, input) {
                if(!pickupTimeGenerated) {
                    pickupTimeGenerated = !pickupTimeGenerated;
                    onGenerateCb(date, input);
                }
            },
        });

        let returnTimeGenerated = false;

        $("#returnTime").datetimepicker({
            defaultTime: defaultTimeString,
            minDate: '+1970/01/02', // tomorrow
            defaultDate: '+1970/01/02', // tomorrow
            scrollMonth: false,
            onShow: function() {
                this.setOptions({
                    minDate: $('#pickupTime').val() ? $('#pickupTime').val() : false,
                });
            },
            onSelectTime: function(date, input) {
                // $(input).addClass('dont-close');
                $(input).datetimepicker('setOptions', {
                    opened: false,
                });
            },
            onSelectDate: function(date, input) {
                $(input).addClass('dont-close');
                $(input).datetimepicker('setOptions', {
                    opened: true,
                });
            },
            onClose: function(date, input) {
                if(!$(input).hasClass('dont-close')) {
                    $(input).datetimepicker('setOptions', {
                        opened: false,
                    });
                }
                $(input).removeClass('dont-close');
            },
            onChangeDateTime: function(date, input) {
                const pickupDate = $('#pickupTime').datetimepicker('getValue');
                let valid = (pickupDate >= date) ? false : true;
                onChangeDateTimeCb(date, input);

                $('.m-search .e-select').each(function(index, el) {
                    if($(el).find('.e-select__option--active').length == 0) {
                        valid = false;
                    }
                });

                if(valid) {
                    $('.m-search #book').removeClass('e-btn--disabled');
                } else {
                    $('.m-search #book').addClass('e-btn--disabled');
                }
            },
            onGenerate: function(date, input) {
                if(!returnTimeGenerated) {
                    returnTimeGenerated = !returnTimeGenerated;
                    onGenerateCb(date, input);
                }
            },
        });

        $('.m-search .e-select').on('click', function(e) {
            const pickupDate = $('#pickupTime').datetimepicker('getValue');
            const returnDate = $('#returnTime').datetimepicker('getValue');
            let valid = (pickupDate >= returnDate) ? false : true;

            $('.m-search .e-select').each(function(index, el) {
                if($(el).find('.e-select__option--active').length == 0) {
                    valid = false;
                }
            });

            if(valid) {
                $('.m-search #book').removeClass('e-btn--disabled');
            } else {
                $('.m-search #book').addClass('e-btn--disabled');
            }
        });

        $('.m-search #book').on('click', function(e) {
            e.preventDefault();
            const url = $(this).attr('href');
            const defaultDate = new Date();
            const defaultDateString = `${defaultDate.getFullYear()}/${leadingZero(defaultDate.getMonth() + 1)}/${leadingZero(defaultDate.getDate())}`;
            let defaultReturnDateString = `${defaultDate.getFullYear()}/${leadingZero(defaultDate.getMonth() + 1)}/${leadingZero(defaultDate.getDate())}`;

            let defaultReturnDate = new Date(defaultReturnDateString);
            defaultReturnDate.setDate(defaultReturnDate.getDate() + 1);
            defaultReturnDateString = `${defaultReturnDate.getFullYear()}/${leadingZero(defaultReturnDate.getMonth() + 1)}/${leadingZero(defaultReturnDate.getDate())}`;

            const pickupDate = $('#pickupTime').val() ? $('#pickupTime').val() : `${defaultDateString} ${defaultTimeString}`;
            const returnDate = $('#returnTime').val() ? $('#returnTime').val() : `${defaultReturnDateString} ${defaultTimeString}`;
            const pickupPlace = $('#changePickupLocation .e-select__value').text();
            const returnPlace = $('#returnLocation .e-select__value').text();

            const params = {
                "pickupDate": pickupDate,
                "returnDate": returnDate,
                "pickupPlace": pickupPlace,
                "returnPlace": returnPlace
            };

            const searchParams = url + "?" + $.param(params);
            if(searchParams) window.location.href = searchParams;
        });

        // categories
        const select = $(".e-cat-select");
        if (select.length > 0) {
            select.on("click", function (e) {
                e.preventDefault();
                const parent = $(this).parent();

                if (!$(this).hasClass("e-cat-select--active")) {
                    // hide different select boxes
                    parent
                        .find(".e-cat-select")
                        .removeClass("e-cat-select--active");

                    if($(this).hasClass('e-cat-select--laterBreak')) {
                        parent.find('.e-cat-select__options-wrapper').stop().slideUp(300);
                    } else {
                        $(".e-cat-select__options-wrapper").stop().slideUp(300);
                    }

                    // open select box
                    $(this)
                        .find(".e-cat-select__options-wrapper")
                        .stop()
                        .slideDown(300);
                    $(this).addClass("e-cat-select--active");
                } else {
                    // close select box
                    parent
                        .find(".e-cat-select")
                        .removeClass("e-cat-select--active");

                    if($(this).hasClass('e-cat-select--laterBreak')) {
                        parent.find('.e-cat-select__options-wrapper').stop().slideUp(300);
                    } else {
                        $(".e-cat-select__options-wrapper").stop().slideUp(300);
                    }
                }
            });
        }

        const options = $(".e-cat-select__options-wrapper .e-cat");
        if (options.length > 0) {
            options.on("click", function (e) {
                e.stopPropagation();

                const selectBox = $(this).closest('.e-cat-select');
                if(!selectBox.hasClass('e-cat-select--prevent')) {
                    e.preventDefault();

                    const isHomePage = $('.page-home').length > 0 ? true : false;
                    const select = $(this).parent().parent().parent();
                    let breakpoint = 768;

                    if(select.hasClass('e-cat-select--laterBreak')) {
                        breakpoint = 992;
                    }

                    if (!$(this).hasClass("e-cat--active")) {
                        select
                            .find(".e-cat-select__options-wrapper .e-cat")
                            .removeClass("e-cat--active");
                        $(this).addClass("e-cat--active");

                        if(isHomePage) {

                            $.ajax({
                                url: main.ajax_url,
                                type: 'POST',
                                data: {
                                    action: 'load_featured_cars',
                                    type: $(this).data('type'),
                                },
                                beforeSend: function() {
                                    $('.m-results__desktop').addClass('loading');
                                },
                                complete: function() {
                                    $('.m-results__desktop').removeClass('loading');
                                },
                                success: function(res) {
                                    const desktopButtonHtml = $(res).find('.desktop-button').html();
                                    const mobileButtonHtml = $(res).find('.mobile-button').html();
                                    const desktopContent = $(res).find('.desktop').html();

                                    $(".m-results__desktop .m-results__single:not(:first)").remove();

                                    $(".m-results__desktop .row.align-items-stretch").append(desktopContent);

                                    $('#desktopOfferButton').html(desktopButtonHtml);
                                    $('#mobileOfferButton').html(mobileButtonHtml);

                                    // svg inject
                                    const svgs = document.querySelectorAll("img.injectable");
                                    if (svgs) {
                                        SVGInject.setOptions({
                                            onFail: function (img) {
                                                img.classList.remove("injectable");
                                            },
                                        });
                                        SVGInject(svgs);
                                    }

                                    const newOfferSwiper = new Swiper(".m-results .swiper-container", {
                                        slidesPerView: 1,
                                        spaceBetween: 30,
                                        grabCursor: true,
                                        speed: 700,
                                        loop: true,
                                        navigation: {
                                            prevEl: ".m-results .swiper-button-prev",
                                            nextEl: ".m-results .swiper-button-next",
                                        },
                                    });
                                }
                            })
                        } else {

                            const type = $(this).data('type');

                            $.ajax({
                                url: main.ajax_url,
                                type: 'POST',
                                data: {
                                    action: 'load_offer_cars',
                                    type: type,
                                    class: "",
                                    gearbox: "",
                                    fuel: "",
                                    passengers: "",
                                },
                                beforeSend: function() {
                                    $('#app').addClass('loading');
                                    $('.m-cars__container').addClass('loading');
                                    $('.m-cars__head').addClass('loading');
                                },
                                complete: function() {
                                    $('.m-cars__container').removeClass('loading');
                                    $('.m-cars__head').removeClass('loading');
                                    $('#app').remove();
                                },
                                success: function(res) {
                                    const contentHtml = $(res).html();
                                    $('#app').removeClass('loading');
                                    $('.m-cars__container .e-car-box').remove();
                                    $('.m-cars__container .e-find-cta').remove();
                                    $('.m-cars__container').prepend(contentHtml);
                                    $('.m-filters .e-field .e-select__option').removeClass('e-select__option--active');

                                    if(type == 'short') {
                                        $('.m-cars__head').addClass('m-cars__head--hidden');
                                        $('.m-filters').addClass('m-filters--show');

                                        $('.m-filters .e-select .e-select__option[data-all]').each((index, el) => {
                                            $(el).closest('.e-select').find('.e-select__value').text($(el).text());
                                            $(el).addClass('e-select__option--active');
                                        });

                                    } else {
                                        $('.m-cars__head').removeClass('m-cars__head--hidden');
                                        $('.m-filters').removeClass('m-filters--show');
                                    }

                                    // svg inject
                                    const svgs = document.querySelectorAll("img.injectable");
                                    if (svgs) {
                                        SVGInject.setOptions({
                                            onFail: function (img) {
                                                img.classList.remove("injectable");
                                            },
                                        });
                                        SVGInject(svgs);
                                    }
                                }
                            });
                        }
                    }

                    if (window.innerWidth < breakpoint) {
                        select
                            .find(".e-cat-select__options-wrapper")
                            .stop()
                            .slideUp(300);
                        select.removeClass("e-cat-select--active");
                    }

                    const cloneEl = $(this).clone();
                    select.find(".e-cat-select__placeholder").html(cloneEl);
                };

            });
        }

        // select
        if($('.page-offer').length == 0) {
            const selectBox = $(".e-select");
            if (selectBox.length > 0) {
                selectBox.on("click", function (e) {
                    e.preventDefault();
                    if (!$(this).hasClass("e-select--active")) {
                        $(".e-select").removeClass("e-select--active");
                        $(this).addClass("e-select--active");
                    } else {
                        $(".e-select").removeClass("e-select--active");
                    }
                });
            }

            const selectBoxOption = $(".e-select__option");
            if (selectBoxOption.length > 0) {
                selectBoxOption.on("click", function (e) {
                    e.preventDefault();
                    const value = $(this).text();
                    const select = $(this).closest('.e-select');

                    select
                        .removeClass("e-select--placeholder")
                        .find(".e-select__option")
                        .removeClass("e-select__option--active");
                    $(this).addClass("e-select__option--active");

                    select.find(".e-select__value").text(value);

                    if(select.data('contact-form')) {
                        const selector = `select[name="${select.data('contact-form')}"]`;
                        $(selector).val(value);
                    }

                    if(select.is('#changePickupLocation')) {
                        const isDifferentPlace = $('#differentPlace').prop('checked');
                        if(!isDifferentPlace) {
                            const returnSelect = $('#returnLocation');
                            returnSelect.find('.e-select__value').text(value);
                            returnSelect.find('.e-select__option').removeClass('e-select__option--active');
                            returnSelect.find(`.e-select__option:contains(${value})`).addClass('e-select__option--active');
                        }
                    }

                    if(select.closest('.m-filters').length > 0) {
                        let selectedClass = $('#class .e-select__value').text() ? $('#class .e-select__value').text() : '';
                        let selectedGearbox = $('#gearbox .e-select__value').text() ? $('#gearbox .e-select__value').text() : '';
                        let selectedFuel = $('#fuel .e-select__value').text() ? $('#fuel .e-select__value').text() : '';
                        let selectedPassengers = $('#passengers .e-select__value').text() ? $('#passengers .e-select__value').text() : '';

                        if($('#class .e-select__option--active').data('all')) {
                            selectedClass = "";
                        }

                        if($('#gearbox .e-select__option--active').data('all')) {
                            selectedGearbox = "";
                        }

                        if($('#fuel .e-select__option--active').data('all')) {
                            selectedFuel = "";
                        }

                        if($('#passengers .e-select__option--active').data('all')) {
                            selectedPassengers = "";
                        }

                        $.ajax({
                            url: main.ajax_url,
                            type: 'POST',
                            data: {
                                action: 'load_offer_cars',
                                type: 'short',
                                class: selectedClass,
                                gearbox: selectedGearbox,
                                fuel: selectedFuel,
                                passengers: selectedPassengers,
                            },
                            beforeSend: function() {
                                $('.m-cars__container').addClass('loading');
                            },
                            complete: function() {
                                $('.m-cars__container').removeClass('loading');
                            },
                            success: function(res) {
                                const contentHtml = $(res).html();
                                $('.m-cars__container .e-find-cta').remove();
                                $('.m-cars__container .e-car-box').remove();
                                $('.m-cars__container').prepend(contentHtml);

                                // svg inject
                                const svgs = document.querySelectorAll("img.injectable");
                                if (svgs) {
                                    SVGInject.setOptions({
                                        onFail: function (img) {
                                            img.classList.remove("injectable");
                                        },
                                    });
                                    SVGInject(svgs);
                                }
                            }
                        });
                    }
                });
            }
        } else {
            const sectionsWithSelects = ['.m-search', '.m-filters'];
            sectionsWithSelects.forEach((el) => {
                const selectBox = $(`${el} .e-select`);
                if (selectBox.length > 0) {
                    selectBox.on("click", function (e) {
                        e.preventDefault();
                        if (!$(this).hasClass("e-select--active")) {
                            $(".e-select").removeClass("e-select--active");
                            $(this).addClass("e-select--active");
                        } else {
                            $(".e-select").removeClass("e-select--active");
                        }
                    });
                }

                const selectBoxOption = $(`${el} .e-select__option`);
                if (selectBoxOption.length > 0) {
                    selectBoxOption.on("click", function (e) {
                        e.preventDefault();
                        const value = $(this).text();
                        const select = $(this).closest('.e-select');

                        select
                            .removeClass("e-select--placeholder")
                            .find(".e-select__option")
                            .removeClass("e-select__option--active");
                        $(this).addClass("e-select__option--active");

                        select.find(".e-select__value").text(value);

                        if(select.data('contact-form')) {
                            const selector = `select[name="${select.data('contact-form')}"]`;
                            $(selector).val(value);
                        }

                        if(select.is('#changePickupLocation')) {
                            const isDifferentPlace = $('#differentPlace').prop('checked');
                            if(!isDifferentPlace) {
                                const returnSelect = $('#returnLocation');
                                returnSelect.find('.e-select__value').text(value);
                                returnSelect.find('.e-select__option').removeClass('e-select__option--active');
                                returnSelect.find(`.e-select__option:contains(${value})`).addClass('e-select__option--active');
                            }
                        }

                        if(select.closest('.m-filters').length > 0) {
                            let selectedClass = $('#class .e-select__value').text() ? $('#class .e-select__value').text() : '';
                            let selectedGearbox = $('#gearbox .e-select__value').text() ? $('#gearbox .e-select__value').text() : '';
                            let selectedFuel = $('#fuel .e-select__value').text() ? $('#fuel .e-select__value').text() : '';
                            let selectedPassengers = $('#passengers .e-select__value').text() ? $('#passengers .e-select__value').text() : '';

                            if($('#class .e-select__option--active').data('all')) {
                                selectedClass = "";
                            }

                            if($('#gearbox .e-select__option--active').data('all')) {
                                selectedGearbox = "";
                            }

                            if($('#fuel .e-select__option--active').data('all')) {
                                selectedFuel = "";
                            }

                            if($('#passengers .e-select__option--active').data('all')) {
                                selectedPassengers = "";
                            }

                            $.ajax({
                                url: main.ajax_url,
                                type: 'POST',
                                data: {
                                    action: 'load_offer_cars',
                                    type: 'short',
                                    class: selectedClass,
                                    gearbox: selectedGearbox,
                                    fuel: selectedFuel,
                                    passengers: selectedPassengers,
                                },
                                beforeSend: function() {
                                    $('.m-cars__container').addClass('loading');
                                },
                                complete: function() {
                                    $('.m-cars__container').removeClass('loading');
                                },
                                success: function(res) {
                                    const contentHtml = $(res).html();
                                    $('.m-cars__container .e-find-cta').remove();
                                    $('.m-cars__container .e-car-box').remove();
                                    $('.m-cars__container').prepend(contentHtml);

                                    // svg inject
                                    const svgs = document.querySelectorAll("img.injectable");
                                    if (svgs) {
                                        SVGInject.setOptions({
                                            onFail: function (img) {
                                                img.classList.remove("injectable");
                                            },
                                        });
                                        SVGInject(svgs);
                                    }
                                }
                            });
                        }
                    });
                }
            });
        }
    }


    // search box
    const search = $(".m-search");
    if (search.length > 0) {
        // tabs
        $(".m-search__tab").on("click", function (e) {
            e.preventDefault();

            if (!$(this).hasClass("m-search__tab--active")) {
                const boxName = $(this).data("box");
                const selector = `.m-search__box[data-box="${boxName}"]`;

                $(".m-search__box--active").removeClass(
                    "m-search__box--active"
                );
                $(".m-search__tab--active").removeClass(
                    "m-search__tab--active"
                );

                $(selector).addClass("m-search__box--active");
                $(this).addClass("m-search__tab--active");
            }
        });

        // different place of return
        const defaultTextEl = $("#placeholderText");
        const defaultText = defaultTextEl.text();
        $("#differentPlace").on("click", function () {
            const box = $(".m-search .m-search__box");
            const isChecked = $(this).prop("checked");

            if (isChecked) {
                box.addClass("m-search__box--differentPlace");
                defaultTextEl.text("Miejsce odbioru");
            } else {
                const pickupValue = $('#changePickupLocation').find('.e-select__value').text();
                box.removeClass("m-search__box--differentPlace");
                defaultTextEl.text(defaultText);
                const returnSelect = $('#returnLocation');
                returnSelect.find('.e-select__value').text(pickupValue);
                returnSelect.find('.e-select__option').removeClass('e-select__option--active');
                returnSelect.find(`.e-select__option:contains(${pickupValue})`).addClass('e-select__option--active');
            }
        });
    }

    // dropdown
    $(".e-dropdown__heading").on("click", function (e) {
        e.preventDefault();
        const dropdown = $(this).parent();

        if (!dropdown.hasClass("e-dropdown--active")) {
            dropdown.find(".e-dropdown__body").stop().slideDown(300);
            dropdown.addClass("e-dropdown--active");
        } else {
            dropdown.find(".e-dropdown__body").stop().slideUp(300);
            dropdown.removeClass("e-dropdown--active");
        }
    });

    // accordion
    $(".e-accordion__header").on("click", function (e) {
        e.preventDefault();
        const accordion = $(this).parent().parent();
        const option = $(this).parent();

        if (!option.hasClass("e-accordion__option--active")) {
            accordion
                .find(".e-accordion__option")
                .removeClass("e-accordion__option--active");
            accordion.find(".e-accordion__content").stop().slideUp(300);
            option.find(".e-accordion__content").stop().slideDown(300);
            option.addClass("e-accordion__option--active");
        } else {
            accordion
                .find(".e-accordion__option")
                .removeClass("e-accordion__option--active");
            accordion.find(".e-accordion__content").stop().slideUp(300);
        }
    });

    // scroll_to_section
    $(document).on('click', '.scroll_to_section', function (e) {
        e.preventDefault();
        $('html, body').stop().animate({
            scrollTop: $($(this).attr('href')).offset().top - $('.header').height()
        }, 600, 'swing');
    });
    $(document).on('click', '.scroll_to_section_alt', function (e) {
        e.preventDefault();
        $('html, body').stop().animate({
            scrollTop: $('#app').offset().top - 35
        }, 600, 'swing');
    });
    $(document).on('click', '.mobile_scroll_to_section', function (e) {
        e.preventDefault();
        $('.mobile-nav').removeClass('mobile-nav--active');
        $('.header__btn').removeClass('header__btn--active');
        const offsetAdminBar = ($('#wpadminbar').length) ? $('#wpadminbar').height() + 50 : 0;
        $('html, body').stop().animate({
            scrollTop: $($(this).attr('href')).offset().top - $('.header').height() - offsetAdminBar
        }, 600, 'swing');
    });

    $('#reservationEmail').on('blur', function(e) {
        const reservationEmail = $(this).val();
        const reservationId = $('#reservationId').val();

        if(reservationEmail && reservationId) {
            $('#sendReservationCancelRequest').removeClass('e-btn--disabled');
        } else {
            $('#sendReservationCancelRequest').addClass('e-btn--disabled');
        }
    });

    $('#reservationId').on('blur', function(e) {
        const reservationEmail = $('#reservationEmail').val();
        const reservationId = $(this).val();

        if(reservationEmail && reservationId) {
            $('#sendReservationCancelRequest').removeClass('e-btn--disabled');
        } else {
            $('#sendReservationCancelRequest').addClass('e-btn--disabled');
        }
    });

    $('.m-search #sendReservationCancelRequest').on('click', function(e) {
        e.preventDefault();

        $('.m-confirm-popup').addClass('m-confirm-popup--active');
    });

    $('.m-confirm-popup #cancelAction').on('click', function(e) {
       e.preventDefault();
       $('.m-confirm-popup').removeClass('m-confirm-popup--active');
    });

    $('.m-confirm-popup .m-confirm-popup__mask').on('click', function(e) {
       e.preventDefault();
       $('.m-confirm-popup').removeClass('m-confirm-popup--active');
    });

    $('.m-alert-popup .e-btn').on('click', function(e) {
       e.preventDefault();
       $('.m-alert-popup').removeClass('m-alert-popup--active');
    });

    $('.m-alert-popup .m-alert-popup__mask').on('click', function(e) {
       e.preventDefault();
       $('.m-alert-popup').removeClass('m-alert-popup--active');
    });

    function showAlert(message) {
        $('.m-confirm-popup').removeClass('m-confirm-popup--active');
        $('.m-alert-popup .m-alert-popup__header').text(message);
        $('.m-alert-popup').addClass('m-alert-popup--active');
    }

    $('.m-confirm-popup #cancelRequest').on('click', function(e) {
        e.preventDefault();
        const reservationEmail = $('#reservationEmail').val();
        const reservationId = $('#reservationId').val();
        $('.m-confirm-popup').addClass('m-confirm-popup--loading');

        $.ajax({
            url: main.ajax_url,
            dataType: 'json',
            type: 'POST',
            data: {
                action: 'send_reservation_cancel_request',
                reservation_email: reservationEmail,
                reservation_id: reservationId,
            },
            beforeSend: function() {
                $('.m-search [data-box="cancelReservation"] .m-search__form').addClass('loading');
            },
            complete: function(res) {
                $('.m-confirm-popup').removeClass('m-confirm-popup--loading');
                $('.m-confirm-popup').removeClass('m-confirm-popup--active');
                $('.m-search [data-box="cancelReservation"] .m-search__form').removeClass('loading');
                if(!res.responseJSON) {
                    showAlert(main.error_msg);
                }
            },
            success: function(res) {
                if(res.message) {
                    showAlert(res.message);
                }
            }
        });
    });

    AOS.init({
        duration: 600,
        disable: 'phone',
        once: true,
    });
});
